import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const PropertySummaryLoading = () => (
  <Box
    width="100%"
    height="100%"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    gap="s600"
  >
    <div>
      <SkeletonLoader width={172} />
      <SkeletonLoader width={90} />
    </div>
    <div>
      <SkeletonLoader width={56} />
      <SkeletonLoader width={104} />
    </div>
  </Box>
)
